import { makeStyles } from '@material-ui/core'

import Colors from '../../../../constants/Colors'

export default makeStyles(theme => ({
  container: {
    width: '100%',
    minWidth: '12rem',
    maxWidth: '48rem',
    margin: 'auto',
  },
  wrapperManageStoreBtn: {
    padding: '0 1.25rem',
    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
  },
  manageStoresBtn: {
    width: '100%',
    padding: '1rem',
    fontSize: '1rem',
    lineHeight: 1.25,
    [theme.breakpoints.up('sm')]: {
      display: 'block',
      width: '58%',
      maxWidth: '26rem',
      margin: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      display: 'inline-flex',
      width: '100%',
      padding: '0.5rem 0 1rem',
      fontSize: '0.75rem',
      color: Colors.DODGER_BLUE,
    },
  },
  manageStoresBtnEndIcon: {
    transform: 'rotate(-90deg)',
    color: Colors.DODGER_BLUE,
  },
  loadingSingleStore: {
    display: 'block',
    margin: '2rem auto',
  },
}))
